import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
    },
}));



export default function MyProfileComponet(props) {
    const { profileDetails } = props;
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                className={classes.tabs}
            >
                <Tab label="My Profile" {...a11yProps(0)} />
                <Tab label="Contact" {...a11yProps(1)} />
                <Tab label="Activities" {...a11yProps(2)} />
            </Tabs>
            {profileDetails &&
                <div>
                    <TabPanel value={value} index={0} component="div">
                        <div className="detailsItem">
                            <div className="detailsKey">
                                Name :
                            </div>
                            <div className="detailsValue">
                                {profileDetails.name}
                            </div>
                        </div>
                        <div className="detailsItem">
                            <div className="detailsKey">
                                Username :
                            </div>
                            <div className="detailsValue">
                                {profileDetails.username}
                            </div>
                        </div>
                        {/* <div className="detailsItem">
                            <div className="detailsKey">
                                Policies :
                            </div>
                            <div className="detailsValue">
                                {profileDetails.policies}
                            </div>
                        </div> */}
                    </TabPanel>
                    <TabPanel value={value} index={1} component="div">
                        <div className="detailsItem">
                            <div className="detailsKey">
                                Email :
                            </div>
                            <div className="detailsValue">
                                {profileDetails.email}
                            </div>
                        </div>
                        <div className="detailsItem">
                            <div className="detailsKey">
                                Phone :
                            </div>
                            <div className="detailsValue">
                                {profileDetails.phone_number}
                            </div>
                        </div>
                    </TabPanel>
                </div>
            }
        </div>
    );
}